import React, { useCallback, useEffect, useRef, useState } from "react";
import style from "css/zwcad.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import ZwcadFeatureListItem from "components/zwcad/zwcadFeatureListItem";
import Underbar from "components/common/underbar";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import Mobilemenu from "components/common/mobilemenu";
/**
 * Version : 1.0
 * 작성일자 : 2024-02-14
 * 작성자 : 강연승
 * 설명 : ZWCAD 페이지
 */

function Documents() {
  //navigate
  const navigate = useNavigate();
  //반응형
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const [data, setdata] = useState({
    LINK: "",
  });

  const getlist = useCallback(() => {
    let config = {
      params: {
        TITLE: "ZWCAD",
      },
    };
    axios.get("/open/product_fileinfo", config).then((res) => {
      if (res.status === 200) {
        if (res.data.TYPE === "FILE") {
          setdata({ LINK: res.data.FILE_URL });
        } else {
          setdata({ LINK: res.data.LINK });
        }
      }
    });
  }, []);
  useEffect(() => {
    getlist();
  }, [getlist]);

  const location = useLocation();
  const content0Ref = useRef(null);
  const content1Ref = useRef(null);
  const content2Ref = useRef(null);
  const content3Ref = useRef(null);
  const content4Ref = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (location.state === null) {
        content0Ref.current?.scrollIntoView({ behavior: "smooth" });
      } else {
        switch (location.state.title) {
          case 1:
            content0Ref.current?.scrollIntoView({ behavior: "smooth" });
            break;
          case 2:
            content2Ref.current?.scrollIntoView({ behavior: "smooth" });
            break;
          case 3:
            content3Ref.current?.scrollIntoView({ behavior: "smooth" });
            break;
          case 4:
            content4Ref.current?.scrollIntoView({ behavior: "smooth" });
            break;
          default:
            break;
        }
      }
    }, 500); // 0.1초 딜레이

    // 컴포넌트가 언마운트될 때 타이머 정리
    return () => clearTimeout(timer);
  }, [location, isMobile]);

  return (
    <>
      <div className={style.wrapper}>
        <div
          className={style.background}
          ref={content0Ref}
          style={
            isMobile
              ? {
                  backgroundImage:
                    "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/product/documents/documentsmh.png')",
                }
              : {
                  backgroundImage:
                    "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/product/documents/documentsh.png')",
                }
          }
        ></div>
        <div className={style.zwcad_area}>
          <div className={style.zwcad_title_wrap}>
            <div className={isMobile ? style.doc_title : style.zwcad_title}>
              PDF는 역시 {isMobile ? <p /> : ""} Foxit PDF !
            </div>
            <div
              className={isMobile ? style.doc_subtitle : style.zwcad_subtitle}
            >
              데스크탑, 모바일 및 웹을 {isMobile ? <p /> : ""} 동시 지원하는
              진정한 대안 PDF
            </div>
          </div>
        </div>
      </div>
      {isMobile ? (
        <div className="product_mobile_wrapper">
          <div className="product_mobile_body">
            <div className="product_mobile_contents" ref={content1Ref}>
              {" "}
              <img
                alt="documents1"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/documents/documentsm1.png"
                }
              />
            </div>
            <div className="product_mobile_contents" ref={content2Ref}>
              {" "}
              <img
                alt="documents2"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/documents/documentsm2.png"
                }
              />
            </div>{" "}
            <div className="product_mobile_contents" ref={content3Ref}>
              {" "}
              <img
                alt="documents3"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/documents/documentsm3.png"
                }
              />
            </div>{" "}
            <div className="product_mobile_contents">
              {" "}
              <img
                alt="documents4"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/documents/documentsm4.png"
                }
              />
            </div>{" "}
          </div>
        </div>
      ) : (
        <div className="product_wrapper" ref={content1Ref}>
          <div className="product_body">
            <div className="product_contents">
              <img
                alt="zwcad1"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/documents/documents1.png"
                }
              />
            </div>
            <div className="product_contents" ref={content2Ref}>
              <img
                alt="zwcad2"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/documents/documents2.png"
                }
              />
            </div>
            <div className="product_contents" ref={content3Ref}>
              <img
                alt="zwcad3"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/documents/documents3.png"
                }
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Documents;
